import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { EASE } from "./Reveal";

export default function Accordion({ items, testPrefix = "accordion" }) {
  const [open, setOpen] = useState(-1);
  return (
    <div className="divide-y divide-ink/10 border-y border-ink/10">
      {items.map((item, i) => (
        <div key={i}>
          <button
            data-testid={`${testPrefix}-${i}`}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="w-full flex items-center justify-between gap-6 py-5 text-left group"
          >
            <span className="font-display text-lg md:text-xl text-ink group-hover:text-lavdeep transition-colors duration-500">
              {item.q}
            </span>
            <ChevronDown
              size={17}
              strokeWidth={1.5}
              className={`shrink-0 text-ink/50 transition-transform duration-500 ${open === i ? "rotate-180" : ""}`}
            />
          </button>
          <motion.div
            initial={false}
            animate={{ height: open === i ? "auto" : 0, opacity: open === i ? 1 : 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="overflow-hidden"
          >
            <p className="pb-6 pr-8 font-light text-sm leading-relaxed text-ink/70">{item.a}</p>
          </motion.div>
        </div>
      ))}
    </div>
  );
}
